import { Experiment } from '@stone-payments/experiment'
import { AmplitudeExperimentJS } from '@stone-payments/experiment/plugins/amplitude-experiment-js'
import { isProductionAccount } from '@/enums/environment.enum'

class ExperimentSingleton {
  constructor () {
    if (!ExperimentSingleton.instance) {
      this.experiment = new Experiment([
        new AmplitudeExperimentJS(process.env.VUE_APP_EXPERIMENT_KEY, {
          debug: !isProductionAccount(process.env.NODE_ENV)
        })
      ])
      ExperimentSingleton.instance = this
    }
    return ExperimentSingleton.instance
  }

  async setUpUser ({ id, ...user }) {
    await this.experiment.init()
    await this.experiment.start({
      ...(id && { user_id: id }),
      user_properties: { ...user }
    })
  }

  getInstance () {
    return this.experiment
  }

  async isFlagActive (flagName) {
    try {
      const variant = await this.getInstance().variant(flagName)
      return variant.value === 'on'
    } catch (error) {
      return false
    }
  }
}

const experimentSingleton = new ExperimentSingleton()
export default experimentSingleton
